/**
 * Page Header
 */

// Vendors
import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';
import { getCookie, setCookie } from '../framework/utilities';

// Create waypoint
$('.page-header').each(
  (index, element) =>
    new Waypoint({
      element: $(element),
      offset: '75%',
      handler: function (direction) {
        if (direction !== 'down') return;

        $(this.element).addClass('page-header--in-view');
      }
    })
);

if ($('.banner').length && !getCookie(`site-banner-close`))
  $('body').addClass('banner--visible');

$('.banner-close a').on('click', (event) => {
  event.preventDefault();
  setCookie(`site-banner-close`, true);
  $('body').removeClass('banner--visible');
});
